import http from "../../../assets/extra/_httpServices";
import { updateLoadingScreen } from "../../../redux/Actions";
import { urls } from "../../../components/common/constants";
import * as types from "./bookingActionType";

const updateCityList = (data) => {
  return {
    type: types.CITY_LIST,
    payload: data,
  }
}
const updateBranchsList = (data) => {
  return {
    type: types.BRANCHES_LIST,
    payload: data,
  }
}
const updateCountryList = (data) => {
  return {
    type: types.COUNTRY_LIST,
    payload: data,
  }
}
const updatePaymentModaList = (data) => {
  return {
    type: types.PAYMENT_MODA_LIST,
    payload: data,
  }
}
export const updateOwnardData = (data) => {
  return {
    type: types.OWNARD_TICKET_DATA,
    payload: data,
  }
}

const updateBusList = (data) => {
  return {
    type: types.BUS_LIST,
    payload: data,
  };
};

const updateTripSheetTableData = (data) => {
  return {
    type: types.TRIP_SHEET_TABLE_DATA,
    payload: data,
  };
};

const updateTripListAll = (data) => {
  return {
    type: types.TRIP_LIST_ALL,
    payload: data,
  };
};
const updateCancelReqTypeList = (data) => {
  return {
    type: types.CAN_REQ_LIST,
    payload: data,
  };
};
//updateTicketNumber
const updateTicketNumber = (data) => {
  return {
    type: types.UPDATE_TICKET_NUMBER,
    payload: data,
  };
}
export const updateOnwardBlockData = (data) => {
  return {
    type: types.UPDATE_ONWARD_BLOCK,
    payload: data,
  }
}

const updateBlockSeatList = (data) => {
  return {
    type: types.UPDATE_BLOCKSEAT_LIST,
    payload: data,
  }
}

export const updateCurrentOwnardData = (data) => {
  return {
    type: types.OWNARD_CURRENT_TICKET_DATA,
    payload: data,
  }
}
export const updateStockCounter = (data) => {
  return {
    type: types.UPDATE_STOCK_COUNTER,
    payload: data,
  }
}

export const updateClassTypeList = (data) => {
  return {
    type: types.UPDATE_CLASS_TYPE_LIST,
    payload: data,
  }
}

export const updateIdTypeList = (data) => ({
  type: types.UPDATE_ID_TYPE_LIST,
  payload: data,
})
export const updateManifestData = (data) => ({
  type: types.MANIFEST_DETAILS,
  payload: data,
});
export const updateCargoVehicleDetails = (data) => ({
  type: types.CARGO_VEHICLE_DETAILS,
  payload: data,
});
export const updateDriverConductorListAll = (data) => ({
  type: types.DRIVER_CONDUCTOR_LIST_ALL,
  payload: data,
});
export const updateCargoDisatch = (data) => ({
  type: types.CARGO_DISATCH,
  payload: data,
});

export const updateIssueCargoPPRListAll = (data) => ({
  type: types.ISSUE_CARGO_PPR,
  payload: data,
})
export const updateStartingFrom = (data) => {
  return {
    type: types.UPDATE_STARTING_FROM,
    payload: data,
  }
}
export const updateAccoTypeData = (data) => {
  return {
    type: types.UPDATE_ACCO_TYPE,
    payload: data,
  }
}
export const updateVariantData = (data) => {
  return {
    type: types.UPDATE_VARIANT_DATA,
    payload: data,
  }
}
export const updateIssueCargoBalance = (data) => ({
  type: types.ISSUE_CARGO_BALANCE,
  payload: data,
})

export const updateKSTDCCityList = (data) => {
  return {
    type: types.KSTDC_CITY_LIST,
    payload: data,
  }
}


export const getCompanyCityPairs = (params) => {
  return (dispatch) => {
    http
      .HttpGet(urls?.getCompanyCityPairs, params)
      .then((response) => {
        if (response.status === 200 && response.data.status) {
          dispatch(updateCityList(response.data.Data.Table));
        } else {
          dispatch(updateCityList([]));
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        dispatch(updateCityList([]));
      });
  };
};

export const getSearchRoutes = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getSearchRoutes, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const getPickupsDropoffs = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getPickupsDropoffs, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const getChart = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getChart, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};
export const getBkgConcessionsLevies = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getBkgConcessionsLevies, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};


//track ticket

export const getBookingPrintData = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.getBookingPrintData, "post", data, {})
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}

export const getTicketNumber = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    http
      .HttpGet(urls.getTicketNumber, data)
      .then((res) => {
        if (res.status === 200 && res.data.status) {
          dispatch(updateTicketNumber(res?.data?.Data?.Table?.[0]?.RunningNo))
          dispatch(updateStockCounter(res?.data?.Data?.Table?.[0]))
        }
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateTicketNumber(''))
        dispatch(updateStockCounter({}))
        reject(error)
      })
  })
}

export const getBookingBalance = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.getBookingBalance, "post", {}, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        if (res.status === 200 && res.data.status) {
          dispatch(updateBranchsList(res?.data?.Data?.Table?.[0]))
        }
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        dispatch(updateBranchsList({}))
        reject(error)
      })
  })
}

export const getCounterBooking = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.getCounterBooking, "post", {}, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}
export const getCounterBooking1 = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.getCounterBooking1, "post", {}, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}



export const getCountryList = (params) => {
  return (dispatch) => {
    http.HttpGet(urls?.getCountryList, params)
      .then((response) => {
        if (response.status === 200 && response.data.status) {
          dispatch(updateCountryList(response.data.Data.Table));
        } else {
          dispatch(updateCountryList([]));
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        dispatch(updateCountryList([]))
      })
  }
}

export const getPaymentModesListAll = (params) => {
  return (dispatch) => {
    http.HttpGet(urls?.getPaymentModesListAll, params)
      .then((response) => {
        if (response.status === 200 && response.data.status) {
          dispatch(updatePaymentModaList(response.data.Data.Table));
        } else {
          dispatch(updatePaymentModaList([]));
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        dispatch(updatePaymentModaList([]))
      })
  }
}
export const getBusList = (body) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(updateLoadingScreen(true));
      http
        .HttpCall(urls.getBusList, "post", body)
        .then((response) => {
          dispatch(updateLoadingScreen(false));
          dispatch(updateBusList(response.data.Data));
          return resolve(response);
        })
        .catch((error) => {
          dispatch(updateLoadingScreen(false));
          dispatch(updateBusList([]));
          console.log("Error: ", error);
          return reject(error);
        });
    });
  };
};

export const addTripSheet = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpCall(urls.addTripSheet, "post", {}, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};
// export const getTripSheetTableData = (params) => {
//   return (dispatch) => {
//     http
//       .HttpGet(urls?.getTripSheetTableData, params)
//       .then((response) => {
//         if (response.status === 200 && response.data.status) {
//           dispatch(updateTripSheetTableData(response.data?.Data?.Table));
//         } else {
//           dispatch(updateTripSheetTableData([]));
//         }
//       })
//       .catch((error) => {
//         console.log("Error: ", error);
//         dispatch(updateTripSheetTableData([]));
//       });
//   };
// };
export const getTripSheetTableData = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getTripSheetTableData, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        if (res.status === 200 && res.data.status) {
          dispatch(updateTripSheetTableData(res.data?.Data?.Table));
        }
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        dispatch(updateTripSheetTableData([]));
        reject(error)
      })
  })
}
export const getTripSheetViewTableData = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getTripSheetViewData2, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};
export const getTripSheetViewData1 = (body) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(updateLoadingScreen(true));
      http
        // .HttpCall(urls.getTripSheetViewData1, "post", body)
        .HttpGet(urls.getTripSheetViewData1, body)
        .then((response) => {
          dispatch(updateLoadingScreen(false));
          return resolve(response);
        })
        .catch((error) => {
          dispatch(updateLoadingScreen(false));
          console.log("Error: ", error);
          return reject(error);
        });
    });
  };
};
//track ticket

export const getTrackTicketData = (body) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(updateLoadingScreen(true));
      http
        .HttpCall(urls.getTrackTicketData, "post", body)
        .then((response) => {
          dispatch(updateLoadingScreen(false));
          return resolve(response);
        })
        .catch((error) => {
          dispatch(updateLoadingScreen(false));
          console.log("Error: ", error);
          return reject(error);
        });
    });
  };
};
export const getTrackTicketMobileData = (body) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(updateLoadingScreen(true));
      http
        .HttpGet(urls.getTrackTicketMobileData, body)
        .then((response) => {
          dispatch(updateLoadingScreen(false));
          return resolve(response);
        })
        .catch((error) => {
          dispatch(updateLoadingScreen(false));
          console.log("Error: ", error);
          return reject(error);
        });
    });
  };
};
export const getBkgPrintDetails = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.getBookingDetailsPrint, "post", data, {})
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}

export const getLockUnlockPNR = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.getPnrLockUnlock, "post", {}, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}

export const getTripListAll = (data) => {
  return (dispatch) => {
    http.HttpGet(urls?.getTripListAllWithUserPrev, data)
      .then((response) => {
        if (response.status === 200 && response.data.status) {
          dispatch(updateTripListAll(response.data.Data));
        } else {
          dispatch(updateTripListAll([]));
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        dispatch(updateTripListAll([]))
      })
  }
};

export const getAdocSearchList = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.getAdocSearchList, "post", data)
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}

export const adhocRefund = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.adhocRefund, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const printDuplicateTicket = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.printTicket, "post", data)
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}

export const cancelTicket = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.cancelTicketV4, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const getPassengersSeatDetails = (body) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(updateLoadingScreen(true));
      http
        .HttpCall(urls.getPassengersSeatDetails, "post", body)
        .then((response) => {
          dispatch(updateLoadingScreen(false));
          return resolve(response);
        })
        .catch((error) => {
          dispatch(updateLoadingScreen(false));
          console.log("Error: ", error);
          return reject(error);
        });
    });
  };
};

export const getBlockSeat = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.getBlockSeat, "post", {}, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}

export const getBlockSeat1 = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.getBlockSeat1, "post", {}, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}

export const getBlockList = (data) => {
  return (dispatch) => {
    http.HttpGet(urls?.getBlockList, data)
      .then((response) => {
        if (response.status === 200 && response.data.status) {
          dispatch(updateBlockSeatList(response.data.Data.Table));
        } else {
          dispatch(updateBlockSeatList([]));
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        dispatch(updateBlockSeatList([]))
      })
  }
};

export const getBlockConfirmListing = (data) => {
  return (dispatch) => {
    http.HttpGet(urls?.getBlockConfirmListing, data)
      .then((response) => {
        if (response.status === 200 && response.data.status) {
          dispatch(updateBlockSeatList(response.data.Data.Table));
        } else {
          dispatch(updateBlockSeatList([]));
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        dispatch(updateBlockSeatList([]))
      })
  }
};

export const setUnBlock = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.setUnBlock, "post", {}, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}

export const getUnBlockTableData = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getBlockList, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};
export const getCancelEticketList = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getCancelEticketList, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};
//cancel E-ticket

export const getCancelReqTypeListAll = (data) => {
  return (dispatch) => {
    http.HttpGet(urls?.getCancelReqList, data)
      .then((response) => {
        if (response.status === 200 && response.data.status) {
          dispatch(updateCancelReqTypeList(response.data.Data));
        } else {
          dispatch(updateCancelReqTypeList([]));
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        dispatch(updateCancelReqTypeList([]))
      })
  }
};
export const getTripListAllForFilter = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .GetRequestCached(urls.getTripListAllForFilter, data, isCache, cacheDuration)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const getDataForSeatTransfer = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getDataForSeatTransfer, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};


export const getTransferSeatSave = (body) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http.callApiForArray(urls.getTransferSeatSave, body)
      .then((res) => {
        const success = [];
        const error = []
        const data = res?.[0]?.map((val) => val?.data?.status === false ? error.push(val) : success.push(val))
        dispatch(updateLoadingScreen(false))
        return resolve([success, error])
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}


//Prepone/postpone ticket
export const getDataForPreponePostpone = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getDataForPreponePostpone, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};



export const UpdatePreponePostPone = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.UpdatePreponePostPone, "post", {}, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}


export const getDataForModification = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getDataForModification, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const UpdateModifyPickupDropOff = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.UpdateModifyPickupDropOff, "post", {}, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}

export const getDataForBlockToConfirm = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getDataForBlockToConfirm, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const updateBlockToConfirm = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.updateBlockToConfirm, "post", {}, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}

export const getSentLink = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getSentLink, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const getLockUnlockTableData = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.getAdocSearchList, "post", data, {})
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}
// export const getLockUnlockPNR = (data) => (dispatch) => {
//   return new Promise((resolve, reject) => {
//     dispatch(updateLoadingScreen(true))
//     http
//       .HttpCall(urls.getPnrLockUnlock, "post", {}, data)
//       .then((res) => {
//         dispatch(updateLoadingScreen(false))
//         return resolve(res)
//       })
//       .catch((error) => {
//         dispatch(updateLoadingScreen(false))
//         reject(error)
//       })
//   })
// }


//current Ticket Booking
export const getSearchRoutesOffline = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getSearchRoutesOffline, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const updateCurrentBooking = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.updateCurrentBooking, "post", {}, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}


export const getCurrBookingPrintData = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.getCurrBookingPrintData, "post", data, {})
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}


export const updateAdvOwnardDiscount = (data) => {
  return {
    type: types.UPDATE_ADVOWARD_DISCOUNT,
    payload: data,
  };
}
export const updateAdvReturnDiscount = (data) => {
  return {
    type: types.UPDATE_ADVORETURN_DISCOUNT,
    payload: data,
  };
}


export const updateCurrOwnardDiscount = (data) => {
  return {
    type: types.UPDATE_CURROWARD_DISCOUNT,
    payload: data,
  };
}
export const updateCurrReturnDiscount = (data) => {
  return {
    type: types.UPDATE_CURRRETURN_DISCOUNT,
    payload: data,
  };
}

export const getTrackTicketSms = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.getTrackTicketSms, "post", data, {})
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}

export const getClassTypeList = (params) => {
  return (dispatch) => {
    http
      .HttpGet(urls?.getClassTypeMasterList, params)
      .then((response) => {
        if (response.status === 200 && response.data.status) {
          dispatch(updateClassTypeList(response.data.Data.Table));
        } else {
          dispatch(updateClassTypeList([]));
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        dispatch(updateClassTypeList([]));
      });
  };
};

export const getTripCodeDetails = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getTripCodeDet, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};


export const getOldTrackTicketMobileData = (body) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(updateLoadingScreen(true));
      http
        // .HttpCall(urls.getTripSheetViewData1, "post", body)
        .HttpGet(urls.getOldTrackTicketMobileData, body)
        .then((response) => {
          dispatch(updateLoadingScreen(false));
          return resolve(response);
        })
        .catch((error) => {
          dispatch(updateLoadingScreen(false));
          console.log("Error: ", error);
          return reject(error);
        });
    });
  };
};

export const getOldTrackTicketData = (body) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(updateLoadingScreen(true));
      http
        .HttpGet(urls.getOldTrackTicketData, body)
        .then((response) => {
          dispatch(updateLoadingScreen(false));
          return resolve(response);
        })
        .catch((error) => {
          dispatch(updateLoadingScreen(false));
          console.log("Error: ", error);
          return reject(error);
        });
    });
  };
};


export const saveCargoBooking = (body) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      http.HttpCall(urls?.CargoBookingSave, "post", {}, body)
        .then((response) => {
          dispatch(updateLoadingScreen(false));
          return resolve(response);
        })
        .catch((error) => {
          dispatch(updateLoadingScreen(false));
          console.log("Error: ", error);
          return reject(error);
        });
    });
  };
};

export const getCargoVehicleDetails = (body) => {
  return (dispatch) => {
    http.HttpGet(urls.CargoVehicleDetails, body)
      .then((response) => {
        if (response.status === 200 && response.data.status) {
          dispatch(
            updateCargoVehicleDetails(response.data.Data.Table)
          );
        } else {
          dispatch(updateCargoVehicleDetails([]));
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };
};
export const getDriverConductorListAll = (body) => {
  return (dispatch) => {
    http.HttpCall(urls.DriverConductorListAll, "post", {}, body)
      .then((response) => {
        if (response.status === 200 && response.data.status) {
          dispatch(
            updateDriverConductorListAll(response.data.Data)
          );
        } else {
          dispatch(updateDriverConductorListAll([]));
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };
};
export const saveCargoDisatch = (body) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      http.HttpCall(urls.CargoDisatchV2, "post", {}, body)
        .then((response) => {
          return resolve(response);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  };
};



export const CargoDelivery = (body) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(updateLoadingScreen(true));
      http.HttpCall(urls.CargoDelivery, "post", {}, body)
        .then((response) => {
          dispatch(updateLoadingScreen(false));
          return resolve(response);
        })
        .catch((error) => {
          dispatch(updateLoadingScreen(false));
          console.log("Error: ", error);
          return reject(error);
        });
    });
  };
};

export const getTripListAllForFilterUserPrev = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .GetRequestCached(urls.getTripListAllWithUserPrev, data, isCache, cacheDuration)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const QuotaReleaseInsertUpdate = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.QuotaReleaseInsertUpdate, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};
export const getIdtypesList = (body) => {
  return (dispatch) => {
    http.HttpCall(urls?.IDProofMaster, "post", {}, body)
      .then((response) => {
        if (response.status === 200 && response.data.status) {
          dispatch(updateIdTypeList(response.data.Data));
        } else {
          dispatch(updateIdTypeList([]));
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        dispatch(updateIdTypeList([]));
      });

  };
};
export const getCargoCharges = (body) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(updateLoadingScreen(true));
      http.HttpGet(urls?.CargoBookingCharge, body)
        .then((response) => {
          dispatch(updateLoadingScreen(false));
          return resolve(response);
        })
        .catch((error) => {
          dispatch(updateLoadingScreen(false));
          console.log("Error: ", error);
          return reject(error);
        });
    });
  };
};

export const getManifestDetails = (body) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(updateLoadingScreen(true));
      http.HttpGet(urls.GetManifestDetails, body)
        .then((response) => {
          dispatch(updateLoadingScreen(false));
          return resolve(response);
        })
        .catch((error) => {
          dispatch(updateLoadingScreen(false));
          console.log("Error: ", error);
          return reject(error);
        });
    });
  };
};


export const GetCargoReceiptDetails = (body) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(updateLoadingScreen(true));
      http.HttpGet(urls.GetCargoReceiptDetails, body)
        .then((response) => {
          dispatch(updateLoadingScreen(false));
          return resolve(response);
        })
        .catch((error) => {
          dispatch(updateLoadingScreen(false));
          console.log("Error: ", error);
          return reject(error);
        });
    });
  };
};
export const CargoReceive = (body) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(updateLoadingScreen(true));
      http.HttpCall(urls.CargoReceive, "post", {}, body)
        .then((response) => {
          dispatch(updateLoadingScreen(false));
          return resolve(response);
        })
        .catch((error) => {
          dispatch(updateLoadingScreen(false));
          console.log("Error: ", error);
          return reject(error);
        });
    });
  };
};
export const GetLuggageForDelivery = (body) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(updateLoadingScreen(true));
      http.HttpCall(urls.GetLuggageForDelivery, "post", {}, body)
        .then((response) => {
          dispatch(updateLoadingScreen(false));
          return resolve(response);
        })
        .catch((error) => {
          dispatch(updateLoadingScreen(false));
          console.log("Error: ", error);
          return reject(error);
        });
    });
  };
};



export const getCargoBookingConfiguration = (body) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(updateLoadingScreen(true));
      http.HttpGet(urls?.getCargoBookingConfiguration, body)
        .then((response) => {
          dispatch(updateLoadingScreen(false));
          return resolve(response);
        })
        .catch((error) => {
          dispatch(updateLoadingScreen(false));
          console.log("Error: ", error);
          return reject(error);
        });
    });
  };
};
export const getIssueCargoPPRListAll = (body) => {
  return (dispatch) => {
    http.HttpGet(urls.getIssueCargoPPRListAll, body)
      .then((response) => {
        if (response.status === 200 && response.data.status) {
          dispatch(
            updateIssueCargoPPRListAll(response.data.Data.Table?.[0]?.RunningNo || '')
          );
        } else {
          dispatch(updateIssueCargoPPRListAll(''));
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };
};
export const getManifestPrintDetails = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getManifestPrintDetails, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};
export const getStartingFromData = (params) => {
  return (dispatch) => {
    http
      .HttpGet(urls?.getStartingFromData, params)
      .then((response) => {
        const parseData = JSON.parse(response.data)
        if (parseData?.Success) {
          dispatch(updateStartingFrom(parseData?.data))
        } else {
          dispatch(updateStartingFrom([]));

        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        dispatch(updateStartingFrom([]));
      });
  };
};


export const getAccoTypeData = (params) => {
  return (dispatch) => {
    http
      .HttpGet(urls?.getAccoTypeData, params)
      .then((response) => {
        const parseData = JSON.parse(response.data)
        if (parseData?.Success) {
          dispatch(updateAccoTypeData(parseData?.data))
        } else {
          dispatch(updateAccoTypeData([]));

        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        dispatch(updateAccoTypeData([]));
      });
  };
};


export const getVariantData = (params) => {
  return (dispatch) => {
    http
      .HttpGet(urls?.getVariantData, params)
      .then((response) => {
        const parseData = JSON.parse(response.data)
        if (parseData?.Success) {
          dispatch(updateVariantData(parseData?.data))
        } else {
          dispatch(updateVariantData([]));

        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        dispatch(updateVariantData([]));
      });
  };
};

export const getSearchRouteFromTownID = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getSearchRouteFromTownID, data)
      .then((response) => {
        const parseData = JSON.parse(response?.data)
        dispatch(updateLoadingScreen(false));
        return resolve(parseData);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};


export const getBusID = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getBusID, data)
      .then((response) => {
        dispatch(updateLoadingScreen(false));
        const parseData = JSON.parse(response.data)
        return resolve(parseData);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const getSeatLayoutData = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getSeatLayoutData, data)
      .then((response) => {
        const parseData = JSON.parse(response?.data)
        return resolve(parseData);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const getPickUpID = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getPickUpID, data)
      .then((response) => {
        const parseData = JSON.parse(response?.data)
        return resolve(parseData);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};


export const getUnBlockTableConfBkgData = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getBlockConfirmListing, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const getRefreshSearchCache = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getRefreshSearchCache, data)
      .then((res) => {
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};
export const getSearchRoutesBlockSeats = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getSearchRoutesBlockSeats, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false));
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};



export const getIssueCargoPPRDetails = (body) => {
  return (dispatch) => {
    http.HttpGet(urls.CargoPPRDetailsCounter, body)
      .then((response) => {
        if (response.status === 200 && response.data.status) {
          dispatch(
            updateIssueCargoPPRListAll(response.data.Data.Table?.[0]?.RunningNo || '')
          );
          dispatch(
            updateIssueCargoBalance(response.data.Data.Table?.[0]?.Balance || '')
          );
        } else {
          dispatch(updateIssueCargoBalance(''));
          dispatch(updateIssueCargoPPRListAll(''));
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };
}

export const getSeniorFare = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getSeniorFare, data)
      .then((response) => {
        const parseData = JSON.parse(response?.data)
        dispatch(updateLoadingScreen(false));
        return resolve(parseData);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const getFetchPNRDetails = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getFetchPNRDetails, data)
      .then((response) => {
        const parseData = JSON.parse(response?.data)
        dispatch(updateLoadingScreen(false));
        return resolve(parseData);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const getFare = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getFare, data)
      .then((response) => {
        const parseData = JSON.parse(response?.data)
        dispatch(updateLoadingScreen(false));
        return resolve(parseData);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};
export const updateBusSeatsBlocking = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.updateBusSeatsBlocking, data)
      .then((response) => {
        const parseData = JSON.parse(response?.data)
        dispatch(updateLoadingScreen(false));
        return resolve(parseData);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const updateBusSeatsUpdate = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.updateBusSeatsUpdate, data)
      .then((response) => {
        const parseData = JSON.parse(response.data)
        dispatch(updateLoadingScreen(false));
        return resolve(parseData);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};


export const getBusSeatsCancellationCharges = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getBusSeatsCancellationCharges, data)
      .then((response) => {
        const parseData = JSON.parse(response.data)
        dispatch(updateLoadingScreen(false));
        return resolve(parseData);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const getBusSeatsCancellation = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getBusSeatsCancellation, data)
      .then((response) => {
        const parseData = JSON.parse(response?.data)
        dispatch(updateLoadingScreen(false));
        return resolve(parseData);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};



export const getPNRStatus = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));

    http
      .HttpGet(urls.getPNRStatus, data)
      .then((response) => {
        try {
          const parser = new DOMParser();
          const xmlDoc = parser.parseFromString(response?.data, "text/xml");

          // Retrieve the `string` element with namespace handling
          const stringElement = xmlDoc.getElementsByTagNameNS(
            "http://e-reserve.in/webservice",
            "string"
          )[0];

          if (stringElement && stringElement.textContent) {
            const jsonString = stringElement.textContent;
            const pnrData = JSON.parse(jsonString);

            dispatch(updateLoadingScreen(false));
            resolve(pnrData);
          } else {
            throw new Error("Failed to retrieve JSON content from XML response.");
          }
        } catch (parseError) {
          dispatch(updateLoadingScreen(false));
          reject(parseError);
        }
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};


export const getIdProofMasterList = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.IDProofMasterListAll, "post", data, {})
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}


export const getAdhocCancellation = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getAdhocCancellation, data)
      .then((response) => {
        dispatch(updateLoadingScreen(false));
        return resolve(response);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};
export const getAdhocPer = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getAdhocPer, data)
      .then((response) => {
        dispatch(updateLoadingScreen(false));
        return resolve(response);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const getKSTDCCityList = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getKSTDCCityList, data)
      .then((res) => {
        if (res.status === 200 && res.data.status) {
          dispatch(updateKSTDCCityList(res.data.Data.Table))
        } else {
          dispatch(updateLoadingScreen(false));
          dispatch(updateKSTDCCityList([]))
        }
        return resolve(res);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        dispatch(updateKSTDCCityList([]))
        reject(error);
      });
  });
};

export const getPOSBookingModifyOrderID = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.getPOSBookingModifyOrderID, "post", data, {})
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}



export const getKSTDCTrackTicketList = (body) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(updateLoadingScreen(true));
      http
        .HttpGet(urls.getKSTDCTrackTicketList, body)
        .then((response) => {
          dispatch(updateLoadingScreen(false));
          return resolve(response);
        })
        .catch((error) => {
          dispatch(updateLoadingScreen(false));
          console.log("Error: ", error);
          return reject(error);
        });
    });
  };
};

export const getKSTDCTrackTicket = (body) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(updateLoadingScreen(true));
      http
        .HttpGet(urls.getKSTDCTrackTicket, body)
        .then((response) => {
          dispatch(updateLoadingScreen(false));
          return resolve(response);
        })
        .catch((error) => {
          dispatch(updateLoadingScreen(false));
          console.log("Error: ", error);
          return reject(error);
        });
    });
  };
};

export const updatePOSCheckAndConfirm = (data, cancelToken) => (dispatch) => {
  return new Promise((resolve, reject) => {
    http
      .HttpGetWithCancel(urls.updatePOSCheckAndConfirm, data, cancelToken)
      .then((res) => {
        return resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export const updatePOSHoldRelease = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.updatePOSHoldRelease, "post", data, {})
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}


export const updatePOSSeatHoldReturn = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.updatePOSSeatHoldReturn, "post", {}, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}
export const updatePOSModCancel = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.updatePOSModCancel, "post", data, {})
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}
export const updatePOSCheckAndConfirmReturn = (data, cancelToken) => (dispatch) => {
  return new Promise((resolve, reject) => {
    http
      .HttpGetWithCancel(urls.updatePOSCheckAndConfirmReturn, data, cancelToken)
      .then((res) => {
        return resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
export const updatePOSHoldReleaseReturn = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.updatePOSHoldReleaseReturn, "post", data, {})
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}
export const updatePOSSeatHold = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true))
    http
      .HttpCall(urls.updatePOSSeatHold, "post", {}, data)
      .then((res) => {
        dispatch(updateLoadingScreen(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false))
        reject(error)
      })
  })
}
export const getPOSModCheckAndConfirm = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    http
      .HttpGet(urls.getPOSModCheckAndConfirm, data)
      .then((res) => {
        return resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export const getAdhocCancellationWithRef = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoadingScreen(true));
    http
      .HttpGet(urls.getAdhocCancellationWithRef, data)
      .then((response) => {
        dispatch(updateLoadingScreen(false));
        return resolve(response);
      })
      .catch((error) => {
        dispatch(updateLoadingScreen(false));
        reject(error);
      });
  });
};

export const getCancelTripSelect = (body) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(updateLoadingScreen(true));
      http
        .HttpGet(urls.getCancelTripSelect, body)
        .then((response) => {
          return resolve(response);
        })
        .catch((error) => {
          dispatch(updateLoadingScreen(false));
          return reject(error);
        });
    });
  };
};